import { heroStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-10 pt-10 md:pt-16 pb-12 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="rise-in">
            <div className="flex items-center gap-3 mb-5 md:mb-7">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
                <i className="ri-bookmark-3-line"></i>
                第 47 期 · 入口索引已更新
              </span>
              <span className="hidden sm:block text-xs tracking-[0.3em] text-foreground-400">
                NO.47 / WEEKLY
              </span>
            </div>

            <h1 className="font-heading text-4xl md:text-6xl font-black leading-[1.15] tracking-tight text-foreground-950">
              黑料免费
              <span className="block mt-2 text-primary-600">获取方式与渠道入口</span>
            </h1>

            <p className="mt-6 md:mt-7 text-base md:text-lg leading-8 text-foreground-700 max-w-xl">
              点开就能拿到<strong className="font-semibold text-foreground-950">黑料免费</strong>的完整
              <strong className="font-semibold text-foreground-950">获取方式</strong>、可用的
              <strong className="font-semibold text-foreground-950">渠道入口</strong>与一份看得懂的
              <strong className="font-semibold text-foreground-950">攻略</strong>。
              找不到入口、不会看内容，这两件最常卡住人的事，这里一次讲清楚。
            </p>

            <div className="mt-8 md:mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="#index"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看本期导读
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ways"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-foreground-950/20 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                获取方式一览
              </a>
            </div>

            <div className="mt-10 md:mt-12 grid grid-cols-3 gap-4 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-t border-foreground-950/15 pt-3">
                  <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rise-in relative">
            <div className="relative w-full aspect-[4/5] sm:aspect-[4/3] lg:aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20still%20life%20with%20stacked%20warm%20cream%20paper%20sheets%2C%20a%20folded%20crimson%20ribbon%2C%20scattered%20vintage%20newspaper%20clippings%20and%20amber%20dried%20flowers%20arranged%20on%20a%20matte%20beige%20paper%20background%2C%20soft%20directional%20daylight%2C%20subtle%20shadows%2C%20minimal%20art%20direction%2C%20no%20text%2C%20warm%20neutral%20and%20crimson%20palette%2C%20high%20detail&width=900&height=1100&seq=hl-hero-cover-01&orientation=portrait"
                alt="黑料免费获取方式与渠道入口攻略封面图"
                title="黑料免费 · 获取方式与渠道入口攻略"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-4 left-4 right-4 sm:right-auto sm:w-72 rounded-lg bg-background-50 border border-foreground-950/10 p-4 md:p-5">
              <p className="text-[11px] tracking-[0.25em] text-foreground-400">封面导读</p>
              <p className="mt-2 font-heading text-base font-bold text-foreground-950 leading-snug">
                三步定位你的入口
              </p>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                先分类 → 再挑入口 → 最后用关键词收窄，顺序对了能省一半时间。
              </p>
            </div>

            <span className="hidden lg:flex absolute -top-4 -right-4 w-16 h-16 items-center justify-center rounded-full bg-secondary-500 text-background-50 text-xs font-medium tracking-widest">
              攻略
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}